import React from 'react';
import { ReactComponent as NotFound } from 'src/modules/circles/assets/not-found.svg';
import { BodyTextMedium, HeadingText50, pxToRem } from '@modernhealth/vital-components';
import styled from '@emotion/styled';
import { Trans, useTranslation } from 'react-i18next';

import { ErrorFallbackTestId } from './testIds';
import { ExternalLink } from 'src/shared/components/ExternalLink';

export const ErrorFallback = () => {
    const { t } = useTranslation();
    return (
        <Wrapper data-testid={ErrorFallbackTestId.Wrapper}>
            <Container>
                <NotFound />
                <HeadingText50
                    as="h2"
                    css={{ textAlign: 'center' }}
                    marginTop={22}
                    fontColor="gray85"
                >
                    {t('dashboard:fallback.title')}
                </HeadingText50>
                <BodyTextMedium
                    css={{ marginBottom: pxToRem(49), textAlign: 'center' }}
                    fontColor="gray65"
                >
                    {t('dashboard:fallback.content')}
                </BodyTextMedium>
                <BodyTextMedium css={{ textAlign: 'center' }} fontColor="gray65">
                    <Trans
                        t={t}
                        ns="dashboard"
                        i18nKey="fallback.footer"
                        components={{
                            email: <Email />,
                        }}
                    />
                </BodyTextMedium>
            </Container>
        </Wrapper>
    );
};

const Wrapper = styled.div({
    display: 'flex',
    justifyContent: 'center',
    marginTop: pxToRem(80),
});

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: pxToRem(493),
});

const Email: React.FC<{ children?: string }> = ({ children }) => (
    <ExternalLink href={`mailto:${children}`}>
        <BodyTextMedium as="span" centered css={{ marginBottom: pxToRem(22) }}>
            {children}
        </BodyTextMedium>
    </ExternalLink>
);
